import React from 'react';
import Text from 'Components/Text';
import Button, { buttonColor } from 'Components/Button';
import { STEP_ID } from 'constants/boatApplication';

export default ({personPowerCapacity, isFinalReview, goToStep, boatDetailsRequestInProcess}) => {
  if (boatDetailsRequestInProcess) return null;
  if (!personPowerCapacity) return null;
  const hasSpecifiedEngineWeight = Number(personPowerCapacity.reqSpecifiedEngineWeight) > 0;
  if (personPowerCapacity.appMaxNumberOfPersons === undefined &&
    personPowerCapacity.apprMaxHP === undefined &&
    personPowerCapacity.appMaxWeight === undefined &&
    personPowerCapacity.apprMaxHPDualSteering === undefined &&
    !hasSpecifiedEngineWeight) return null;

  return (
    <section className='scene_section'>
      <header>Approved Person/ Weight Capacities</header>
      {personPowerCapacity.appMaxNumberOfPersons !== undefined &&
        personPowerCapacity.appMaxPersonsWeight !== undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary _margin_right_30'
            textClassName='text__text_primary'
            label='Approved Max. Persons / Max. Persons Weight'
            value={[
              personPowerCapacity.appMaxNumberOfPersons ? personPowerCapacity.appMaxNumberOfPersons.toString() : '',
              personPowerCapacity.appMaxPersonsWeight,
            ]}
            units={['', 'Lbs.']}
            decimalDigits={[0, 0]}
          />
        )}
      {personPowerCapacity.appMaxWeight !== undefined && (
        <Text
          mainWrapperClassName='text__wrapper_primary'
          textClassName='text__text_primary'
          label='Approved Maximum Weight'
          value={personPowerCapacity.appMaxWeight}
          units=' Lbs.'
          decimalDigits={0}
        />
      )}
      {personPowerCapacity.appMaxNumberOfPersons !== undefined &&
        personPowerCapacity.appMaxPersonsWeight === undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary _margin_right_30'
            textClassName='text__text_primary'
            label='Approved Max. Persons'
            value={personPowerCapacity.appMaxNumberOfPersons}
          />
        )}
      {personPowerCapacity.apprMaxHPDualSteering !== undefined && (
        <Text
          mainWrapperClassName='text__wrapper_primary'
          textClassName='text__text_primary'
          label='Approved Maximum Horsepower with Remote Steering'
          value={personPowerCapacity.apprMaxHPDualSteering}
          units=' HP'
          decimalDigits={2}
        />
      )}
      {personPowerCapacity.apprMaxHP !== undefined && (
        <Text
          mainWrapperClassName='text__wrapper_primary _margin_right_30'
          textClassName='text__text_primary'
          label='Approved Maximum Horsepower'
          value={personPowerCapacity.apprMaxHP}
          units=' HP'
        />
      )}
      {hasSpecifiedEngineWeight && (
        <Text
          mainWrapperClassName='text__wrapper_primary'
          textClassName='text__text_primary'
          label='Specified Engine Weight'
          value={personPowerCapacity.reqSpecifiedEngineWeight}
          units=' Lbs.'
          decimalDigits={0}
        />
      )}
      {isFinalReview && (
        <Button
          color={buttonColor.planeOrange}
          label='Edit'
          buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
          fontSize={14}
          onClick={() => goToStep(STEP_ID.WEIGHT_CAPACITY, true)}
        />
      )}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/PersonWeightCapacity.jsx